module.exports = __webpack_public_path__ + "static/die-casting-36e76a1e93f51390eefa99ff913d52e3.png";